import { render, staticRenderFns } from "./SpatialSpanSequence.vue?vue&type=template&id=f93646ea&scoped=true&"
import script from "./SpatialSpanSequence.vue?vue&type=script&lang=js&"
export * from "./SpatialSpanSequence.vue?vue&type=script&lang=js&"
import style0 from "./SpatialSpanSequence.vue?vue&type=style&index=0&id=f93646ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93646ea",
  null
  
)

export default component.exports